import isEqual from 'lodash/isEqual';
import { computed } from 'vue';

export const computedObject = (getter, debugOptions) =>
  computed((oldValue) => {
    const newValue = getter(oldValue);
    return oldValue != null && isEqual(oldValue, newValue) ? oldValue : newValue;
  }, debugOptions);
